import React, { useState } from 'react';

import BasicDropdown from '../../../common/BasicDropdown/BasicDropdown';
import ConfirmationDialog from '../../../common/ConfirmationDialog/ConfirmationDialog';
import Label from '../../../common/Labels/Label';
import TimeRangePicker from '../../../TimeRangePicker/TimeRangePicker';
import WorkspaceSelectionDropdown from '../../../common/WorkspaceSelectionDropdown/WorkspaceSelectionDropdown';

export const ORCHESTRATION_STATUS = {
  Active: 'ready',
  Inactive: 'Inactive',
  All: 'all',
}

export const TASK_RUN_STATUS = {
  Running: 'Running',
  Success: 'Success',
  Failure: 'Failure',
  All: 'all',
}

const STATUS_OPTIONS = [
  {
    id: ORCHESTRATION_STATUS.All,
    label: 'All Statuses',
  },
  {
    id: ORCHESTRATION_STATUS.Active,
    label: 'Active',
  },
  {
    id: ORCHESTRATION_STATUS.Inactive,
    label: 'Inactive',
  },
]

const TASK_RUN_STATUS_OPTIONS = [
  {
    id: TASK_RUN_STATUS.All,
    label: 'All Statuses',
  },
  {
    id: TASK_RUN_STATUS.Running,
    label: 'Running',
  },
  {
    id: TASK_RUN_STATUS.Success,
    label: 'Success',
  },
  {
    id: TASK_RUN_STATUS.Failure,
    label: 'Failure',
  },
]

export const ALL_TIME = 'All time';

export const RELATIVE_TIME_RANGES = [
  { id: 'all-time', type: ALL_TIME, duration: null },
  { id: 'seconds-30', type: 'Last 30 seconds', duration: { seconds: -30 } },
  { id: 'seconds-60', type: 'Last 60 seconds', duration: { seconds: -60 } },
  { id: 'minutes-5', type: 'Last 5 minutes', duration: { minutes: -5 } },
  { id: 'minutes-15',type: 'Last 15 minutes', duration: { minutes: -15 } },
  { id: 'minutes-30', type: 'Last 30 minutes', duration: { minutes: -30 } },
  { id: 'hours-1', type: 'Last hour', duration: { hours: -1 } },
  { id: 'hours-3', type: 'Last 3 hours', duration: { hours: -3 } },
  { id: 'hours-6', type: 'Last 6 hours', duration: { hours: -6 } },
  { id: 'hours-12', type: 'Last 12 hours', duration: { hours: -12 } },
  { id: 'days-1', type: 'Last day', duration: { days: -1 } },
  { id: 'days-2', type: 'Last 2 days', duration: { days: -2 } },
  { id: 'days-7', type: 'Last 7 days', duration: { days: -7 } },
];

const POPOVER_TO_SIDE = {
  mt: 1,
  left: 108,
  bottom: -264,
}

export const OrchestrationTableFilterModal = ({
  workspaces = [],
  filter = {
    workspaces: [],
    timeRange: RELATIVE_TIME_RANGES[0],
    status: ORCHESTRATION_STATUS.All,
    taskRunStatus: TASK_RUN_STATUS.All,
  },
  showDialog = false,
  onDialogToggle = () => {},
  onFilterConfirm = () => {},
  onClear = () => {},
}) => {
  const [selectedStatus, setSelectedStatus] = useState(filter.status);
  const [selectedTaskRunStatus, setSelectedTaskRunStatus] = useState(filter.taskRunStatus);
  const [selectedWorkspaces, setSelectedWorkspaces] = useState(filter.workspaces);
  const [selectedTimeRange, setSelectedTimeRange] = useState(filter.timeRange);

  const handleConfirmation = () => {
    onFilterConfirm({
      status: selectedStatus,
      taskRunStatus: selectedTaskRunStatus,
      workspaces: selectedWorkspaces,
      timeRange: selectedTimeRange,
    });
  }

  return (
    <ConfirmationDialog
      title="Filter"
      confirmButtonText="Apply"
      cancelButtonText="Clear All"
      modalAnimationKey="orchestration-admin-table-filter"
      showDialog={showDialog}
      onDialogToggle={onDialogToggle}
      onConfirm={handleConfirmation}
      onCancel={onClear}
    >
      <div className="flex flex-col w-small-modal mx-2 my-3">
        <div className="flex flex-col m-1">
          <Label className="my-1" bold>Workspace</Label>
          <WorkspaceSelectionDropdown
            workspaces={workspaces}
            selectedWorkspaces={selectedWorkspaces}
            setSelectedWorkspaces={setSelectedWorkspaces}
          />
        </div>
        <div className="flex flex-col m-1">
          <Label className="my-1" bold>Orchestration Status</Label>
          <BasicDropdown
            values={STATUS_OPTIONS}
            selectedValue={selectedStatus}
            onValueSelected={setSelectedStatus}
            hideLabelInSmallViewports={false}
            dropdownLabel=""
          />
        </div>
        <div className="flex m-1 items-center">
          <div className="flex flex-col">
            <Label className="my-1" bold>Task Run Status</Label>
            <BasicDropdown
              values={TASK_RUN_STATUS_OPTIONS}
              selectedValue={selectedTaskRunStatus}
              onValueSelected={setSelectedTaskRunStatus}
              hideLabelInSmallViewports={false}
              dropdownLabel=""
            />
          </div>
          <Label className="mx-2 mt-8">within</Label>
          <div className="flex flex-col">
            <Label className="my-1" bold>Timeframe</Label>
            <TimeRangePicker
              onChange={setSelectedTimeRange}
              selectedRange={selectedTimeRange}
              relativeRanges={RELATIVE_TIME_RANGES}
              popoverStyle={POPOVER_TO_SIDE}
              popoverDirection="left"
              hideFullLabelOnRange
            />
          </div>
        </div>
      </div>
    </ConfirmationDialog>
  )
}

export default OrchestrationTableFilterModal;
